import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import { qk } from "@/lib/query-keys";
import { toSearchParams, type TimeRange } from "@/lib/time-range";
import { JourneySchema, type Journey } from "@/lib/validation";
import type { UseMetricOptions } from "./useTraffic";

export function useJourney(range: TimeRange, options: UseMetricOptions = {}) {
  return useQuery<Journey>({
    queryKey: qk.metrics.journey(range),
    queryFn: async ({ signal }) => {
      const raw = await api.get<unknown>(
        `/api/v1/metrics/journey?${toSearchParams(range).toString()}`,
        { signal },
      );
      return JourneySchema.parse(raw);
    },
    enabled: options.enabled !== false,
    staleTime: 60_000,
  });
}
